(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gg-autumn-sync"] && !Shopify.designMode) return;
  try {
    async function syncAutumnCards() {
    const source = document.querySelector('[data-gg-autumn-sync]');
    if (!source || source.dataset.started || !source.dataset.url) return;
    source.dataset.started = 'true';
    const members = new Set();
    let page = 1;
    try {
      while (page) {
        const url = new URL(source.dataset.url, location.origin);
        url.searchParams.set('section_id', 'gg-autumn-membership');
        url.searchParams.set('page', String(page));
        const response = await fetch(url, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('Membership unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = doc.querySelector('[data-gg-autumn-members]');
        if (!data) throw new Error('Membership unavailable');
        data.textContent.split('|').filter(Boolean).forEach(handle => members.add(handle));
        const next = Number(data.dataset.next);
        page = next > page ? next : 0;
      }
      const grid = document.querySelector('#gf-products');
      if (!grid) return;
      const template = source.querySelector('template');
      const update = () => {
        grid.querySelectorAll('product-card[handle]').forEach(card => {
          const badge = card.querySelector('.gg-autumn-card');
          const info = card.querySelector('.product-card__info');
          const eligible = members.has(card.getAttribute('handle'));
          if (eligible && !badge && info) info.before(template.content.cloneNode(true));
          if (!eligible && badge) badge.remove();
        });
      };
      update();
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; update(); });
      }).observe(grid, {childList: true, subtree: true});
    } catch (error) {
      source.dataset.started = '';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAutumnCards, {once: true});
  else syncAutumnCards();
  document.addEventListener('shopify:section:load', syncAutumnCards);
  } catch(e) { console.error(e); }
})();

})();
